import React from 'react';
import { useParams } from 'react-router-dom';

import PageHeader from '../../modules/page-header';

const DetailedOrderBreadcrumbsContainer: React.FC = () => {
  const params = useParams<{ id: string }>();
  return (
    <PageHeader
      items={[
        { link: '/orders', title: 'Реестр' },
        { link: `/orders/${params.id}`, title: `Поставка ${params.id}` },
      ]}
      iconType="order"
    />
  );
};

export default DetailedOrderBreadcrumbsContainer;
